import { EntityDefinition } from '@/types/crud';

export const unifiedRolesEntity: EntityDefinition = {
  name: 'unifiedRoles',
  displayName: 'Role Management',
  apiEndpoint: '/rbac/roles',
  fields: [
    {
      key: 'display_name',
      label: 'Role Name',
      type: 'text',
      required: true
    },
    {
      key: 'role_name',
      label: 'Internal Name',
      type: 'text',
      required: true
    },
    {
      key: 'description',
      label: 'Description',
      type: 'textarea',
      required: false
    },
    {
      key: 'role_type',
      label: 'Role Type',
      type: 'select',
      required: true,
      options: [
        { value: 'PLATFORM', label: 'Platform' },
        { value: 'TENANT', label: 'Tenant' }
      ]
    },
    {
      key: 'scope_type',
      label: 'Scope Type',
      type: 'select',
      required: true,
      options: [
        { value: 'PLATFORM', label: 'Platform' },
        { value: 'TENANT', label: 'Tenant' }
      ]
    },
    {
      key: 'is_active',
      label: 'Status',
      type: 'boolean',
      required: true
    },
    {
      key: 'created_at',
      label: 'Created',
      type: 'datetime',
      required: false,
      readOnly: true
    },
    {
      key: 'updated_at',
      label: 'Updated',
      type: 'datetime',
      required: false,
      readOnly: true
    }
  ],
  
  tableColumns: [
    {
      key: 'display_name',
      label: 'Role Name',
      width: '20%'
    },
    {
      key: 'role_name',
      label: 'Internal Name',
      width: '15%'
    },
    {
      key: 'description',
      label: 'Description',
      width: '25%'
    },
    {
      key: 'role_type',
      label: 'Role Type',
      width: '10%'
    },
    {
      key: 'scope_type',
      label: 'Scope Type',
      width: '10%'
    },
    {
      key: 'is_active',
      label: 'Status',
      width: '10%'
    },
    {
      key: 'created_at',
      label: 'Created',
      width: '10%'
    }
  ],

  permissions: {
    create: 'ROLE_CREATE',
    read: 'ROLE_READ',
    update: 'ROLE_UPDATE',
    delete: 'ROLE_DELETE'
  }
};
